import { useEffect, useState } from 'react';
import { RevealButtonProps } from './types';

const RevealButton = (props: RevealButtonProps) => {
  const [isMoreRevealed, setIsMoreRevealed] = useState(
    props.isMoreRevealed || false
  );

  const wrapperClassName = [
    'flex',
    'items-center',
    props.size === 'large' ? '' : 'text-sm',
    props.className || '',
  ];

  const className = [
    'flex',
    'justify-center',
    'items-center',
    'rounded-full',
    props.size === 'large' ? 'w-5' : 'w-4',
    props.size === 'large' ? 'h-5' : 'h-4',
    'bg-grey-10',
    'dark:bg-grey-80',
    'hover:bg-primary',
    'active:bg-black-light',
    'active:text-primary',
    'font-bold',
    props.isDisabled ? 'cursor-not-allowed' : 'cursor-pointer',
  ];

  const iconClassName = [
    'material-icons',
    'select-none',
    props.size === 'large' ? 'text-md' : 'text-sm',
    props.isDisabled ? 'text-grey-30 dark:text-white' : '',
  ];

  const handleClick = () => {
    setIsMoreRevealed(!isMoreRevealed);
    props.setIsMoreRevealed?.(!isMoreRevealed);
  };

  useEffect(() => {
    props.onToggle?.(!isMoreRevealed);
  }, [isMoreRevealed]);

  return (
    <div className={wrapperClassName.join(' ')}>
      <div className={className.join(' ')} onClick={handleClick}>
        {isMoreRevealed ? (
          <span className={iconClassName.join(' ')}>expand_less</span>
        ) : (
          <span className={iconClassName.join(' ')}>expand_more</span>
        )}
      </div>
      <p
        className={`pl-2 ${
          props.isDisabled ? 'text-grey-30' : 'text-black'
        } select-none`}
      >
        {isMoreRevealed
          ? props.revealedLabel || ''
          : props.notRevealedLabel || ''}
      </p>
    </div>
  );
};

export default RevealButton;
